import { render, staticRenderFns } from "./ShopAddress.vue?vue&type=template&id=6c255979"
import script from "./ShopAddress.vue?vue&type=script&lang=js"
export * from "./ShopAddress.vue?vue&type=script&lang=js"
import style0 from "./ShopAddress.vue?vue&type=style&index=0&id=6c255979&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports